import CampaignList from 'external/components/Campaign/List/List';

function ScreensCampaignsList() {
  return <CampaignList />;
}

export default ScreensCampaignsList;
